import Vue from 'vue'
import { createApp } from 'vue'
import App from './App.vue'
import router from "./router"
import VideoPlayer from 'vue-video-player'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import mitt from 'mitt';
 
const emitter = mitt();

require('video.js/dist/video-js.css')
import 'lib-flexible'
// import './utils/rem'
import 'swiper/swiper-bundle.css'

import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'video.js/dist/video-js.css';


const app = createApp(App)
app.config.globalProperties.$emitter = emitter;
app.use(ElementPlus)
app.use(Vant);
app.use(VideoPlayer)
app.use(VueAwesomeSwiper)
app.use(router)

app.mount('#app')
